import { jsx as _jsx } from "react/jsx-runtime";
import { Grid, Typography } from 'seagull';
import { agreementNameValidator } from '~/business-logic/validators';
import { AgreementName } from '~/components/AgreementStudioPage/AgreementName/AgreementName';
import EditableTableCell from '../EditableTableCell/EditableTableCell';
import { getAgreementName } from '../EditDraftsTable.utils';
import styles from './Cells.module.scss';
export default function AgreementNameCell(param) {
    let { draft, index, onOpenModal, isDisabled, disabledTooltip } = param;
    const onClick = ()=>onOpenModal({
            shouldSubmit: async (draft)=>Promise.resolve(agreementNameValidator(draft.title()) === true),
            renderContent: (param)=>{
                let { draft, setDraft } = param;
                return {
                    title: 'Agreement name',
                    testId: "edit-agreement-name-modal",
                    onSubmit: (defaultBehavior)=>{
                        defaultBehavior();
                    },
                    content: /*#__PURE__*/ _jsx(Grid, {
                        align: "center",
                        className: styles.agreementName,
                        children: /*#__PURE__*/ _jsx(AgreementName, {
                            agreementTitle: draft.title(),
                            setAgreementTitle: (title)=>setDraft(draft.setTitle(title)),
                            showWarning: true,
                            setAgreementTitleValid: ()=>{},
                            label: "Agreement name",
                            testId: "edit-agreement-name-modal"
                        })
                    })
                };
            }
        });
    return /*#__PURE__*/ _jsx(EditableTableCell, {
        testId: "edit-agreement-name-".concat(index),
        onClick: onClick,
        isDisabled: isDisabled,
        disabledTooltip: disabledTooltip,
        children: /*#__PURE__*/ _jsx(Typography, {
            ellipsis: true,
            testId: "agreement-name-".concat(index),
            variant: draft.title() ? 'paragraph1' : 'paragraph2',
            skin: draft.title() ? 'standard' : 'secondary',
            children: getAgreementName(draft)
        })
    });
}
